import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { db } from "../../../firebase/firebase";
import { updateDoc, doc } from "firebase/firestore"; // FIX: Added the missing imports
import { QueryKeys } from "config/query-keys";

// Assuming ApplicationPayloadInterface is defined in a DTO file
interface ApplicationPayloadInterface {
    id: string; // The application document ID
    jobId: string;
    applicantId: string; // The applicant's UID
    status: string;
}

const updateCandidateApplication = async ({ id, status }: ApplicationPayloadInterface): Promise<void> => {
    try {
        // There's no need to query for the document if you already have its ID.
        // The 'id' passed in the payload is the unique ID of the application document.
        // This is much more direct and efficient.
        if (!id) {
            throw new Error("Application document ID is missing.");
        }

        const applicationDocRef = doc(db, "applications", id);

        // Update the document directly using its reference
        await updateDoc(applicationDocRef, { status: status });

    } catch (error) {
        console.error("Error updating candidate application:", error);
        throw error;
    }
};

export const useUpdateCandidateApplication = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateCandidateApplication,
        onSuccess: async (_, variables) => {
            // Invalidate the query for the specific list of candidates to trigger a refetch
            // This ensures the UI updates with fresh data from the server.
            await queryClient.invalidateQueries({
                queryKey: [QueryKeys.CANDIDATE, variables.jobId]
            });
        },
        onError: (error) => {
            notification.error({
                message: "Update Failed",
                description: error instanceof Error ? error.message : "Failed to update candidate's application status.",
            });
        },
    });
};